import { useNavigate, useSearchParams } from "react-router-dom";

import AgencyForm from "./AgencyForm";
import AgencyTable from "./AgencyTable";
import Modal from "shared/components/feedback/modals/MasterModal";
import PageWrapper from "app/components/PageWrapper";

const FormPresenter = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("id");

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "add") {
        return (
            <Modal title="Add new agency" onRequestClose={onClose}>
                <AgencyForm key="new" onClose={onClose} />
            </Modal>
        );
    }

    const parsedId = Number.parseInt(id);

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Edit agency" onRequestClose={onClose}>
                <AgencyForm
                    agencyIdToEdit={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const Agencies = () => {
    return (
        <PageWrapper
            title="Agencies"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <FormPresenter />
            <AgencyTable />
        </PageWrapper>
    );
};

export default Agencies;
